import { FC } from 'react';

import { formatCostInCents } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import { Link } from '@hh.ru/redux-spa-middleware';

import HoverTip, { TipPlacement } from 'bloko/blocks/drop/Tip/HoverTip';
import HSpacing from 'bloko/blocks/hSpacing';
import Icon, { IconColor, IconScale, IconView } from 'bloko/blocks/icon';
import BlokoLink from 'bloko/blocks/link';
import Text from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import styles from 'components/Dashboard/DashboardAveragePricePerClick/DashboardAveragePricePerClick.module.less';

const TrlKeys = {
    title: 'campaign.avgPricePerClick.title',
    hoverTip: 'campaign.avgPricePerClick.hoverTip',
    currency: 'currency.short',
};

const DashboardAveragePricePerClick: FC<{
    averagePricePerClickInCents: number;
    urlToStatistics: string;
    dataQa?: string;
}> = ({ averagePricePerClickInCents, urlToStatistics, dataQa }) => {
    const trl = useTrls();

    return (
        <div>
            <div>
                <Text Element="span">{trl(TrlKeys.title)}</Text>
                <HSpacing base={1} />
                <HoverTip placement={TipPlacement.Top} render={() => trl(TrlKeys.hoverTip)}>
                    <span className={styles.icon}>
                        <Icon initial={IconColor.Gray40} scale={IconScale.Small} view={IconView.QuestionMark} />
                    </span>
                </HoverTip>
            </div>
            <VSpacing base={1} />
            <BlokoLink Element={Link} to={urlToStatistics} data-qa={dataQa}>
                {formatCostInCents(averagePricePerClickInCents)}
                {NON_BREAKING_SPACE}
                {trl(TrlKeys.currency)}
            </BlokoLink>
        </div>
    );
};

export default DashboardAveragePricePerClick;
